import { SVGProps, Ref, forwardRef } from 'react';

export const PopcornFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M9.316 15.96c-.403.023-.843.04-1.32.04-.48 0-.92-.017-1.323-.04L6.076 5.82c.634.073 1.275.114 1.92.114q.966-.001 1.917-.115z"
                fill="currentColor"
            />
            <path
                d="M.496 4.137a16.6 16.6 0 0 0 4.367 1.495l.6 10.217c-2.615-.343-3.18-1.162-3.193-1.182z"
                fill="currentColor"
            />
            <path
                d="M13.722 14.667c-.014.02-.579.839-3.197 1.182l.602-10.217a16.6 16.6 0 0 0 4.368-1.495z"
                fill="currentColor"
            />
            <path
                d="M7.995 0a3.54 3.54 0 0 1 2.32.854c.36-.121.748-.187 1.15-.187 1.375 0 2.563.767 3.125 1.879.26.14.462.274.616.39a15.4 15.4 0 0 1-7.21 1.798c-2.538 0-5.01-.629-7.212-1.797.154-.117.355-.25.615-.39.562-1.113 1.75-1.88 3.124-1.88.404 0 .792.066 1.152.187A3.54 3.54 0 0 1 7.995 0"
                fill="currentColor"
            />
        </g>
    </svg>
));
PopcornFilledSize16Glyph.displayName = 'PopcornFilledSize16Glyph';
